import { Select, Space, Typography } from 'antd';
import { DatabaseOutlined } from '@ant-design/icons';
import { DataSource, ProductAlternative } from '../../types/product';

const { Text } = Typography;

interface ProviderOption {
  label: string;
  value: string;
  provider: DataSource;
  productId: string;
  qualityScore: number;
  isCurrent: boolean;
}

interface ProviderSelectorProps {
  currentProvider: DataSource;
  currentProductId: string;
  currentScore: number;
  alternatives?: ProductAlternative[];
  onChange: (productId: string, provider: DataSource) => void;
}

export function ProviderSelector({
  currentProvider,
  currentProductId,
  currentScore,
  alternatives = [],
  onChange,
}: ProviderSelectorProps) {
  const options: ProviderOption[] = [
    {
      label: `${currentProvider} (Current)`,
      value: currentProductId,
      provider: currentProvider,
      productId: currentProductId,
      qualityScore: currentScore,
      isCurrent: true,
    },
    ...alternatives.map((alt) => ({
      label: alt.provider,
      value: alt.product_id,
      provider: alt.provider as DataSource,
      productId: alt.product_id,
      qualityScore: alt.quality_score,
      isCurrent: false,
    })),
  ];

  const handleChange = (value: string) => {
    const selected = options.find((opt) => opt.value === value);
    if (selected) {
      onChange(selected.productId, selected.provider);
    }
  };

  if (alternatives.length === 0) {
    return (
      <Space>
        <DatabaseOutlined />
        <Text strong>{currentProvider}</Text>
        <Text type="secondary">(Score: {currentScore})</Text>
      </Space>
    );
  }

  return (
    <Space>
      <DatabaseOutlined />
      <Text>Data Source:</Text>
      <Select
        value={currentProductId}
        onChange={handleChange}
        style={{ minWidth: 200 }}
        optionLabelProp="label"
      >
        {options.map((option) => (
          <Select.Option
            key={option.value}
            value={option.value}
            label={option.label}
          >
            <Space
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <span>
                {option.provider}
                {option.isCurrent && (
                  <Text type="secondary" style={{ marginLeft: 8 }}>
                    (Current)
                  </Text>
                )}
              </span>
              <Text type="secondary">Score: {option.qualityScore}</Text>
            </Space>
          </Select.Option>
        ))}
      </Select>
    </Space>
  );
}
